import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, Globe, Mail } from 'lucide-react';
import styles from './TalkWithUs.module.css';
import logo from '../../../logo.jpg';

function TalkWithUs() {
  // Configuração de animação para os cards
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" }
    })
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <motion.img 
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          src={logo} 
          alt="Logo Empresa" 
          className={styles.logo} 
        />
      </header>

      <main className={styles.content}>
        <motion.h1 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={styles.title}
        >
          Como podemos ajudar?
        </motion.h1>
        <p className={styles.subtitle}>
          Escolha uma das opções abaixo para conhecer mais sobre nossa jornada e serviços.
        </p>

        <div className={styles.grid}>
          {/* Card Principal de Redirecionamento */}
          <motion.div 
            custom={0}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            className={`${styles.card} ${styles.primaryCard}`}
            onClick={() => window.location.href = '/about'} // Altere para sua rota
          >
            <div className={styles.iconWrapper}>
              <Globe size={32} />
            </div>
            <div className={styles.cardInfo}>
              <h3>Conheça a Empresa</h3>
              <p>Explore nossa história, valores e soluções completas em nossa página oficial.</p>
            </div>
            <ArrowRight className={styles.arrow} />
          </motion.div>

          {/* Opções Secundárias */}
          <motion.div 
            custom={1}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            className={styles.card}
            onClick={() => window.location.href = '/support'}
          >
            <MessageCircle size={24} className={styles.secondaryIcon} />
            <div className={styles.cardInfo}>
              <h4>WhatsApp</h4>
              <p>Fale direto com um consultor.</p>
            </div>
          </motion.div>

          <motion.div 
            custom={2}
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            className={styles.card}
            onClick={() => window.location.href = '/support'}
          >
            <Mail size={24} className={styles.secondaryIcon} />
            <div className={styles.cardInfo}>
              <h4>E-mail</h4>
              <p>Envie sua proposta comercial.</p>
            </div>
          </motion.div>
        </div>
      </main>

      <footer className={styles.footer}>
        <p>© 2026 Jungle Artigos Militares. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default TalkWithUs;